<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('转账')}}</div>
		<div><router-link to="/my/transferRecord" style="color:#000000;">{{$t('转账记录')}}</router-link></div>
	</header>
	<div class="z-body withdraw-body" style="height: 100%;bottom:0px;background:#F5F5F5;">
		<div class="z-flex withdraw-row">
			<div>{{$t('资产')}}</div>
			<div>{{amount_before}}{{data.amount}}{{amount_after}}</div>
		</div>
		<div class="z-flex withdraw-row">
			<div>{{$t('对方账号')}}</div>
			<div style="height: 100%;width:80%;border-bottom:1px solid #dfb15f;">
				<input type="text" v-model="mobile" style="height: 100%;width:100%;" :placeholder="$t('邮箱')">
			</div>
		</div>
		<div class="z-flex withdraw-row">
			<div>{{$t('转账金额')}}</div>
			<div style="height: 100%;width:80%;border-bottom:1px solid #dfb15f;">
				<input type="number" v-model="money" style="height: 100%;width:100%;" :placeholder="amount_before+amount_after">
			</div>
		</div>
		<div class="z-flex withdraw-row">
			<div>{{$t('支付密码')}}</div>
			<div style="height: 100%;width:80%;border-bottom:1px solid #dfb15f;">
				<input type="password" v-model="paypwd" style="height: 100%;width:100%;" :placeholder="$t('请输入')+$t('支付密码')">
			</div>
		</div>
		<section style="text-align: center">
			<div @click="doPost" class="common-btn">{{$t('提交')}}</div>
		</section>
		<div class="withdraw-tips">
			<p style="color:#FA5E00;">{{$t('重要提示')}}</p>
			<div v-html="data.desc" style="margin-bottom: 80px;"></div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name: 'withdraw',
	data() {
		return {
			data:{
				amount:'',
				desc:''
			},
			mobile:'',
			money:'',
			uid:0,
			paypwd:''
			
		}
	},
	mounted() {

	},
	created() {
		this.doInit()
	},
	methods: {
		doInit:function () {
			this.get('api/account/transferconf', {}).then((res) => {
				if (res.code == 0) {
					this.data = res.data
				}
			})
		},
		doPost:function () {
			let _this =  this;
			_this.get('api/member/search', {keyword:_this.mobile}).then((res) => {
				if (res.code == 0 && res.data.length>0) {
					_this.uid = res.data[0]['id'];
					_this.post('api/Account/transfer', {
						money:_this.money,
						uid:_this.uid,
						paypwd:_this.paypwd
					}).then((res) => {
						_this.$store.commit('layer',res.msg)
						if (res.code == 0) {
							_this.jump('/my')
						}
					})
				}
				else {
					_this.$store.commit('layer',_this.$t('暂无数据'))
				}
			})
			
		},
	}
}
</script>
<style scoped>
.withdraw-tips {
	font-size: 16px;
	padding: 10px;
}
.withdraw-tips p{
	margin-bottom: 10px;
}
.withdraw-row {
	height:50px;
	justify-content:space-between;
	border-bottom: 1px solid #F5F5F5;
	padding:0 10px;
}
.withdraw-row div:nth-child(1){
	color: #aaa5a5;
}
</style>


// WEBPACK FOOTER //
// src/pages/my/transfer.vue